var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "analytics-nav" },
    _vm._l(_vm.analyticsNav, function (category) {
      return _c(
        "b-nav",
        { key: category.title, attrs: { horizontal: "" } },
        [
          _vm._l(category.links, function (link) {
            return !link.requiresPOS || _vm.hasPOSAccess
              ? _c(
                  "localized-link",
                  {
                    key: link.title,
                    staticClass: "analytics-nav__item",
                    attrs: {
                      "active-class": "analytics-nav__item--active",
                      to: link.uri,
                    },
                  },
                  [
                    _c("a", { staticClass: "analytics-nav__item--normal" }, [
                      _vm._v(_vm._s(_vm.$t(link.title))),
                    ]),
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c(
            "b-nav-item-dropdown",
            {
              staticClass: "analytics-nav__dropdown",
              attrs: {
                "toggle-class": "analytics-nav__dropdown--toogle",
                right: "",
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "button-content" }, slot: "button-content" },
                [
                  _c("i", {
                    staticClass: "fi fi-list",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm._l(category.links, function (_link) {
                return !_link.requiresPOS || _vm.hasPOSAccess
                  ? _c(
                      "b-dropdown-item",
                      {
                        key: `dropdown-${_link.title}`,
                        on: {
                          click: function ($event) {
                            return _vm.onClickDropDown(_link)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t(_link.title)) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e()
              }),
            ],
            2
          ),
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }